import {ProductWidget} from '@/lib/TypesOpenApi';

export function findProducts(
  products: Array<ProductWidget>,
  produictId: string,
) {
  return products.filter((p: ProductWidget) => p.productId === produictId);
}

export function findProduct(
  products: Array<ProductWidget>,
  produictId: string,
) {
  return products.find((p: ProductWidget) => p.productId === produictId);
}
